import moment from 'moment'

export const PURCHASE_ORDERS = Object.freeze([
  { id: 1, value: 'To Receive and Bill', label: 'To Receive and Bill' },
  { id: 2, value: 'To Receive', label: 'To Receive' }
])

export const OUTBOUND_TYPES = Object.freeze([
  { id: 1, value: 'pick_up', label: 'Pick Up' },
  { id: 2, value: 'transfer', label: 'Transfer' }
])

export const DELIVERY_TYPES = Object.freeze([
  { id: 1, value: 'internal', label: 'Internal' },
  { id: 2, value: 'sewa', label: 'Sewa' },
  { id: 3, value: 'pick_up', label: 'Self Pick Up' }
])

export const OUTBOUND_STATUS = Object.freeze([
  { id: 1, value: 'success', label: 'Success' },
  { id: 2, value: 'cancel', label: 'Cancel' }
])

export const convertDateWithoutTime = (date) => {
  return moment(date, [
    'DD-MM-YYYY HH:mm:ss',
    'YYYY-MM-DD HH:mm:ss',
    'DD-MM-YYYY',
    'YYYY-MM-DD',
    moment.ISO_8601
  ]).format('DD-MM-YYYY')
}

export const convertDateWithTime = (date, format = 'DD-MM-YYYY HH:mm') => {
  return moment(date, [
    'DD-MM-YYYY HH:mm:ss',
    'YYYY-MM-DD HH:mm:ss',
    'DD-MM-YYYY',
    'YYYY-MM-DD',
    moment.ISO_8601
  ]).format(format)
}

export const transformKey = (key) => {
  return key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
}

export const capitalizeWords = (value) => {
  return value.toUpperCase()
}

export const capitalizeFirstLetter = (value) => {
  if (!value) return ''
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const separateNumber = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const base64ToFile = (base64, filename) => {
  const arr = base64.split(',')
  const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/jpeg'
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n >= 0) {
    u8arr[n] = bstr.charCodeAt(n)
    n -= 1
  }

  return new File([u8arr], filename, { type: mime })
}
